// extracted by mini-css-extract-plugin
export default {"container":"FriendRemoved_container__lgDRo","header":"FriendRemoved_header__I7-87","buttons":"FriendRemoved_buttons__B7NaQ","clearButton":"FriendRemoved_clearButton__nW7xl"};